import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/declarations-of-conformity/gen3/content.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LEGACY_ENV_KEY"] */ "/app/src/app/components/LegacyEnvVariables/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/PageLayout/index.tsx");
